module.exports = __webpack_public_path__ + "static/media/ranzijn.2dee8821.jpg";